<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <DialogProduct/>
    <v-data-table
        dense
        sort-by="id"
        :sort-desc="sortdes"
        :headers="headers"
        :search="search"
        :items="products"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitable"
        :server-items-length="totalproduct"
        :loading="loading"
        @update:options="getProducts(opsitable)">
      <template v-slot:top>
        <v-toolbar flat elevation="0">
          <v-text-field
              flat
              solo
              outlined
              clearable
              single-line
              dense
              prepend-icon="search"
              placeholder="Type something"
              v-model="opsitable.search"
              hide-details
              class=""
          ></v-text-field>
          <v-spacer></v-spacer>
          <div class="mt-5 mr-2">
            <v-autocomplete
                clearable
                label="Category"
                @change="getProducts(opsitable)"
                item-text="name"
                item-value="id"
                v-model="opsitable.categoryid"
                :items="categories"
            ></v-autocomplete>
          </div>
          <div class="mt-5">
            <v-autocomplete
                clearable
            label="Brand"
            @change="getProducts(opsitable)"
            item-text="brandname"
            item-value="id"
            v-model="opsitable.brandid"
            :items="brandselect"
            ></v-autocomplete>
          </div>
          <v-btn small elevation="0" class="ml-2" color="primary" @click.native="opennew">
            <v-icon dark>add</v-icon>Tambah
          </v-btn>
          <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getProducts(opsitable)">
            <v-icon dark>refresh</v-icon>Refresh
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.image="{ item }">
        <v-img width="64" class="ma-4" :src="item.image"></v-img>
      </template>
      <template v-slot:item.updateat="{ item }">
        {{formatDate(item.updateat)}}
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.status)"
              small
              text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.aksi="{ item }">
        <v-btn  small dark text @click.native="opendialogEdit(item)" class="blue ml-2">
          <v-icon small dark class="mr-1">check</v-icon>
          Edit
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import DialogProduct from '@/components/admin/product/DialogProduct'

export default {
  name: 'MasterProducts',
  components: { DialogProduct },
  data: () => ({
    search: '',
    sortdes: [true],
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      status: '',
      sortBy: ['id']
    },
    headers: [
      {
        text: 'Id',
        value: 'id',
        width: '10'
      },
      {
        text: 'Category',
        value: 'category.name',
        width: '45'
      },
      {
        text: 'Brand',
        value: 'brand.brandname'
      },
      {
        text: 'Nama Produk',
        value: 'productname'
      },
      {
        text: 'Kode Produk',
        value: 'productcode'
      },
      {
        text: 'Type',
        value: 'producttype'
      },
      {
        text: 'Denom',
        value: 'denom'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Update',
        value: 'updateat'
      },
      {
        text: 'Aksi',
        value: 'aksi'
      }
    ]
  }),
  mounted () {
    this.getBrandSelect(this.opsitable)
    this.getCategory()
    this.getBrands()
    this.getBrandGroups({
      search: '',
      itemsPerPage: 100,
      page: 1,
      categoryid: 1
    })
  },
  computed: {
    ...mapState('AdminProducts', ['loading', 'brandselect', 'categories', 'dialogproduct', 'products', 'totalproduct', 'brandgroups', 'brandgrouptotal'])
  },
  methods: {
    ...mapActions('AdminProducts', ['getBrandGroups', 'getProducts', 'getBrands', 'getBrandSelect', 'getCategory', 'setdialogproduct', 'setselectedproduct', 'setisnewproduct']),
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Enable'
      } else {
        return 'Disable'
      }
    },
    opendialogEdit (item) {
      this.setisnewproduct(false)
      this.setselectedproduct(item)
      this.setdialogproduct(true)
    },
    colorStatus (val) {
      if (parseInt(val) === 0) {
        return 'red'
      }
      if (parseInt(val) === 1) {
        return 'green'
      }
    },
    opennew () {
      this.setisnewproduct(true)
      this.setselectedproduct({
        producttype: 0,
        denom: 10
      })
      this.setdialogproduct(true)
    }
  }
}
</script>

<style scoped>

</style>
